import React from 'react'
import { Close, Edit } from '../NewIcons'
import useTrans from '../../../hooks/useTrans'

const Alert = ({
  variant,
  icon,
  placeholder = 'Notification',
  full,
  closeButton,
  onClick,
  onClose,
  className,
  noClick,
  hideDefaultPrefix
}) => {
  const t = useTrans()
  return (
    <div
      className={`alert ${variant === 'info' ? 'alert--info' : ''} ${full ? 'alert--full' : null} ${
        className ? className : ''
      } ${onClick ? (!noClick ? ' alert--clickable' : '') : ''}`}
      onClick={onClick}
    >
      {icon && <span className="alert__icon">{icon}</span>}
      <p>
        {!icon ? (!hideDefaultPrefix && <strong>{t('Attenzione')}: </strong>) : <></>}
        <span dangerouslySetInnerHTML={{ __html: placeholder}} />
      </p>
      {!noClick && !!onClick && (
        <span className="alert__click">
          <Edit />
        </span>
      )}
      {closeButton && (
        <span className="alert__close">
          <Close onClick={onClose} />
        </span>
      )}
    </div>
  )
}

export default Alert
